import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';
import FixedDataTable from '@shoflo-rundown/fixed-data-table';
import { getPlainTextFromRawRTEState } from '@shoflo-rundown/draft-js-utils';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import EventViewStore from 'flux/stores/EventViewStore';
import {
  RowTypes,
  EditableCellTypes,
  HeaderHeight,
  CompactSpecialColumnWidths,
  DefaultCompactRowHeight,
  DefaultCompactTitleRowHeight,
  CellBorders,
  CellPaddings,
  ItemColumnSegmentWidths,
} from 'flux/stores/cuesheet/CuesheetConstants';
import {
  getCompactItemCellWidthName,
  getCompactItemCellWidthValue,
} from '../cuesheet/rowWidthHelper';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PopoverStore from 'flux/stores/PopoverStore';
import CompactItemCell from 'main/components/show/cuesheet.compact/itemCell/itemCell.jsx';
import {
  startTimeCellRenderer,
  durationCellRenderer,
  presetDurationCellRenderer,
} from 'main/components/show/cuesheet.util/cellRenderers';
import ItemColumnHeaderCell from 'main/components/show/cuesheet/columnHeaderCell/itemColumnHeaderCell.jsx';
import SimpleHeaderCell from 'main/components/show/cuesheet.util/SimpleHeaderCell';
import NavigationMixin from 'main/components/show/cuesheet/navigationMixin';
import HotKeyMixin from 'main/components/show/cuesheet/hotKeyMixin';
import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin';
import CuesheetPopulateMixin from 'main/components/show/cuesheet/cuesheetPopulateMixin.js';
import keyIn from 'shared/lib/immutable/keyIn';
import RowHeightHelper from 'main/components/show/cuesheet/rowHeightHelper';
import AddItemButton from 'main/components/show/cuesheet/addItemButton.jsx';
import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import Spinner from 'shared/components/misc/simpleSpinner.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetCueClockStore from 'flux/stores/cuesheet/CuesheetCueClockStore';

const { Table, Column } = FixedDataTable;

let rowHeights = {};

export default React.createClass({
  displayName: 'FeaturedCuesheet',

  mixins: [
    Reflux.ListenerMixin,
    Reflux.connectFilter(EventViewStore, 'event', (st) =>
      st.filter(keyIn('twentyFourHourClock', 'timeZone')),
    ),
    Reflux.connect(CuesheetStore, 'cuesheet'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connectFilter(PopoverStore, 'popoverVisible', (st) =>
      st.find((val) => val),
    ),
    Reflux.connectFilter(
      CuesheetCueClockStore,
      'toggleFullScreenClock',
      (state) => state.get('toggleFullScreenClock'),
    ),
    NavigationMixin,
    HotKeyMixin,
    CuesheetMixin,
    CuesheetPopulateMixin,
    PureRenderMixin,
  ],

  componentWillMount() {
    RowHeightHelper.init();
  },

  componentDidMount() {
    this.listenTo(CuesheetRowActions.bustRowHeightCache, this._forceRowHeights);
  },

  componentDidUpdate() {
    const curr = this.state.cuesheet;

    //once we have scrolled to the offset, clear the scroll indexes so the user isnt scrolled again
    //every time the cuesheet updates
    if (curr.get('scrollRowIndex') || curr.get('scrollRowWithOffsetIndex')) {
      CuesheetActions.clearScrollIndexes();
    }
  },

  getInitialState() {
    return {
      keysBound: false,
    };
  },

  _forceRowHeights() {
    setTimeout(() => {
      rowHeights = {};

      this.forceUpdate();
    }, 500);
  },

  render() {
    const state = this.state.cuesheet,
      popoverVisible = this.state.popoverVisible,
      rows = state.get('rows'),
      scrollRowIndex = state.get('scrollRowIndex'),
      scrollRowWithOffsetIndex = state.get('scrollRowWithOffsetIndex'),
      scrollColumnIndex = state.get('scrollColumnIndex');

    let contentNode = <Spinner top="50%" left="50%" />;

    let loadFailureNode = this.getLoadFailureNode(_getGridHeight());
    if (loadFailureNode) contentNode = loadFailureNode;

    if (rows && rows.size && !state.get('loading')) {
      /**
       * Don't set scrollIndex/scroll offset props if there is a visible popover. Reference https://github.com/SHOFLO/Issues/issues/1283
       */
      let optionalProps = {};
      if (scrollRowIndex >= 0 && !popoverVisible)
        optionalProps.scrollToRow = scrollRowIndex;
      if (typeof scrollRowWithOffsetIndex !== 'undefined' && !popoverVisible)
        optionalProps.scrollToRowWithOffset = scrollRowWithOffsetIndex;

      contentNode = (
        <Table
          rowClassNameGetter={this._rowClassNameGetter}
          rowGetter={this._rowGetter}
          rowsCount={rows.size + 1}
          {...optionalProps}
          scrollToColumn={scrollColumnIndex}
          rowHeight={DefaultCompactRowHeight}
          rowHeightGetter={this._rowHeightGetter}
          {...this._calculateTableProps()}
        >
          {this._getColumns()}
        </Table>
      );
    }

    /**
     * Prevent text from being highlighted when selected multiple cells with the
     * shift key.
     */
    let cuesheetClasses = classNames(
      'cuesheet',
      'disable-text-highlight',
      'cuesheet-compact',
    );

    return <div className={cuesheetClasses}>{contentNode}</div>;
  },

  /**
   * Gets the class name for the row...used by the FDT
   */
  _rowClassNameGetter(indx) {
    //Classes for footer row
    if (this._isFooterRow(indx)) return '';

    const rowSpec = this._rowGetter(indx);
    // in the event that there are no rows in state, return an empty string
    // this can happen whenever the cuesheet state is cleared. For example,
    // when refreshing rows after an internet disconnect
    if (!rowSpec) return '';
    const rowType = rowSpec.get('type');
    let rowClassName = 'cs-row';

    if (rowType === RowTypes.TitleItem) rowClassName += ' cs-row-title';

    if (rowSpec.get('tracked')) rowClassName += ' cs-row-tracked';

    if (rowSpec.get('rowSelected')) rowClassName += ' cs-row-selected-bulk';

    if (!rowSpec.get('editing') && !rowSpec.get('selected'))
      return rowClassName;

    return rowClassName + ' cs-row-selected';
  },

  /**
   * Calculate some table properties, mostly for dimensions
   */
  _calculateTableProps() {
    const show = this._getCueStateField('show'),
      settings = this._getCueStateField('settings'),
      displayStartTime = show.get('displayStartTime'),
      displayPresetDuration = show.get('displayPresetDuration'),
      displayDuration = show.get('displayDuration');

    let width = getCompactItemCellWidthValue(settings);

    if (displayStartTime) width += CompactSpecialColumnWidths.Start;
    if (displayPresetDuration) width += CompactSpecialColumnWidths.Preset;
    if (displayDuration) width += CompactSpecialColumnWidths.Duration;
    width += CompactSpecialColumnWidths.RowMenuBar;
    width += CompactSpecialColumnWidths.Featured;

    return {
      headerHeight: HeaderHeight,
      width,
      height: _getGridHeight(), //Not sure why, but this seems to prevent the FDT from expanding its height irregularly...if I put it at .95, it does odd things)
    };
  },

  _getColumns() {
    // const columnData = this._getCueStateField('columns'),
    const settings = this._getCueStateField('settings'),
      show = this._getCueStateField('show'),
      event = this.state.event,
      user = this.state.user,
      widthClass = getCompactItemCellWidthName(settings);

    /**
     * Define the item column
     */
    let itemColumn = (
      <Column
        key={'column-item'}
        label="Item"
        width={this._getItemColumnWidth()}
        dataKey={'item'}
        fixed={false}
        cellDataGetter={this._rowDataGetter}
        cellRenderer={this._itemCellRenderer}
        cellClassName={'cs-item-column cs-cell-width-' + widthClass}
        headerRenderer={this._itemColumnHeaderRenderer}
      />
    );

    /**
     * Build special columns list
     */
    let specialColumns = [itemColumn];

    // eslint-disable-next-line no-unused-vars
    const cellRendererArgs = [
      event,
      show,
      user,
      (rowSpec) => this._getRowItem(rowSpec),
      this.state.cuesheet,
    ];

    if (show.get('displayStartTime')) {
      specialColumns.push(
        <Column
          key={'start-time'}
          label="Start"
          width={CompactSpecialColumnWidths.Start}
          dataKey={'startTime'}
          fixed={false}
          cellClassName={'cs-special-column-start cs-special-column'}
          cellDataGetter={this._rowDataGetter}
          cellRenderer={this._startTimeCellRenderer}
          headerRenderer={this._simpleColumnHeaderRenderer}
        />,
      );
    }

    if (show.get('displayPresetDuration')) {
      specialColumns.push(
        <Column
          key={'presetDuration'}
          label="Preset"
          width={CompactSpecialColumnWidths.Preset}
          dataKey={'presetDuration'}
          fixed={false}
          cellClassName={'cs-special-column-preset cs-special-column'}
          cellDataGetter={this._rowDataGetter}
          cellRenderer={this._presetDurationCellRenderer}
          headerRenderer={this._simpleColumnHeaderRenderer}
        />,
      );
    }

    if (show.get('displayDuration')) {
      specialColumns.push(
        <Column
          key={'duration'}
          label="Duration"
          width={CompactSpecialColumnWidths.Duration}
          dataKey={'duration'}
          fixed={false}
          cellClassName={'cs-special-column-duration cs-special-column'}
          cellDataGetter={this._rowDataGetter}
          cellRenderer={this._durationCellRenderer}
          headerRenderer={this._simpleColumnHeaderRenderer}
        />,
      );
    }

    /**
     * Build the add column button column
     */
    let featuredContentColumn = (
      <Column
        key={'column-add-new'}
        label={''}
        width={CompactSpecialColumnWidths.Featured}
        dataKey={'featuredColumn'}
        fixed={false}
        cellRenderer={this._featuredContentRenderer}
        headerRenderer={this._emptyCellRenderer}
      />
    );

    return specialColumns.concat([featuredContentColumn]);
  },

  _startTimeCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
    const { event, user, cuesheet } = this.state;

    if (!rowSpec.get) return <span />;

    const item = this._getRowItem(rowSpec);

    return startTimeCellRenderer(item, rowIndex, user, event, cuesheet);
  },

  _durationCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
    const { event, user, cuesheet } = this.state;

    if (!rowSpec.get) return <span />;

    const item = this._getRowItem(rowSpec);

    return durationCellRenderer(item, rowSpec, rowIndex, user, event, cuesheet);
  },

  _presetDurationCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
    const { event, user, cuesheet } = this.state;

    if (!rowSpec.get) return <span />;

    const item = this._getRowItem(rowSpec);

    return presetDurationCellRenderer(item, rowIndex, event, user, cuesheet);
  },

  // eslint-disable-next-line no-unused-vars
  _featuredContentRenderer(cell, columnId, rowSpec, rowIndex, columnData) {
    let state = this.state.cuesheet,
      featuredColumnId = state.getIn(['userSettings', 'featuredColumn']),
      rowPath = state.getIn(['rows', rowIndex, 'path']),
      item = state.getIn(['rowMap'].concat(rowPath)),
      featuredCell = item ? item.getIn(['cells', featuredColumnId]) : null,
      classes = [];

    if (rowIndex === state.get('featuredCellRowIndex'))
      classes.push('cs-featured-icon-active');

    return featuredCell &&
      featuredCell.get('rteState') &&
      getPlainTextFromRawRTEState(featuredCell.get('rteState').toJS()) ? (
      <span
        onClick={() =>
          CuesheetCellActions.selectItemCell(
            rowIndex,
            EditableCellTypes.ItemTitle,
          )
        }
      >
        <Icon
          name="paragraph"
          className={classNames(classes, 'cs-featured-icon')}
        />
      </span>
    ) : (
      <span />
    );
  },

  _getRowIdFromSpec(rowSpec) {
    return rowSpec && rowSpec.toJS ? rowSpec.get('path')[2] : null;
  },

  _emptyCellRenderer() {
    return <span />;
  },

  /**
   * Get the data for a 'item' cell (which is actually composed of several fields)
   *
   */
  _rowDataGetter(key, rowData) {
    return rowData;
  },

  /**
   * Simple, non-interactive header cell renderer
   *
   * @param  {[type]} label [description]
   * @return [type]         [description]
   */
  _simpleColumnHeaderRenderer(label) {
    return <SimpleHeaderCell>{label}</SimpleHeaderCell>;
  },

  /**
   * Header cell renderer for item column
   */
  _itemColumnHeaderRenderer() {
    return (
      <ItemColumnHeaderCell
        hideProofOfPerformance
        settings={this._getCueStateField('settings')}
      />
    );
  },

  /**
   * Renderer for the item cell
   */
  _itemCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
    if (this._isFooterRow(rowIndex)) {
      return (
        <div className="cs-rows-add-btn-container">
          <AddItemButton />
        </div>
      );
    }

    const item = this._getRowItem(rowSpec),
      trackedUsers = rowSpec.get('trackedUsers'),
      show = this._getCueStateField('show'),
      event = this.state.event,
      user = this.state.user,
      settings = this._getCueStateField('settings'),
      width = getCompactItemCellWidthName(settings),
      titleView = item.get('titleView');

    const height = this._cellHeightGetter(rowIndex, titleView);

    const itemProps = {
      rowId: this._getRowIdFromSpec(rowSpec),
      item,
      user,
      height,
      showStartOn: show.get('startOn'),
      itemNumber: item.get('numberAdjusted'),
      rowIndex,
      timeZone: event.get('timeZone'),
      twentyFourHourClock: event.get('twentyFourHourClock'),
      displayStartTime: show.get('displayStartTime'),
      displayPresetDuration: show.get('displayPresetDuration'),
      autoCountCues: show.get('autoCountCues'),
      autoTimeCalculation: show.get('autoTimeCalculation'),
      displayDescriptions: this._getCueState().getIn([
        'show',
        'displayItemDescriptions',
      ]),
      userId: this._getCueStateField('userId'),
      titleRow: rowSpec.get('type') === RowTypes.TitleItem,
      trackedUsers,
      width,
    };

    return (
      <CompactItemCell
        {...itemProps}
        isTracked={rowSpec.get('tracked')}
        isCopied={rowSpec.get('copied')}
        isTitleCopied={this.isCellCopied(rowIndex, EditableCellTypes.ItemTitle)}
        isDescriptionCopied={this.isCellCopied(
          rowIndex,
          EditableCellTypes.ItemDescription,
        )}
        editing={rowSpec.getIn(['editing', 'type'])}
        checkSelectionStatus={(type) =>
          CuesheetHelper.isCellSelected(rowIndex, type, this.state.cuesheet)
        }
        rowSelected={rowSpec.get('rowSelected')}
        rowType={rowSpec.get('type')}
      />
    );
  },

  _cellHeightGetter(rowIndex, titleView) {
    let height =
      this._rowHeightGetter(rowIndex) -
      CellPaddings.Compact -
      CellBorders.Compact;

    if (titleView) {
      height -= CellPaddings.CompactTitle; // subtract title border padding in compact view
    }

    return height;
  },

  /**
   * Helper function for _rowHeightGetter()
   */
  _getRowHeight(item, rowType, rowId) {
    const itemId = item.get('_id');

    if (rowHeights[itemId]) {
      return rowHeights[itemId];
    }

    // let cellsWithState = item.get('cells')
    //   .filter(cell => cell && cell.get('rteState'));

    let largest =
      this._getItemCellHeight(item, rowId) || DefaultCompactRowHeight;
    let height =
      largest < DefaultCompactRowHeight ? DefaultCompactRowHeight : largest;

    rowHeights[itemId] = height;

    return height;
  },

  // eslint-disable-next-line no-unused-vars
  _getItemCellHeight(item, rowId) {
    const styles = this._getCommonCellHeightCalcStyles(),
      itemWidth = this._getItemColumnSegmentWidth(),
      titleView = item.get('titleView'),
      segmentState = item.get('rteTitleState'),
      className = 'cs-cell cs-cell-format';

    let corruptedCell = false,
      segmentClassName = 'cs-segment-cell ' + className;

    if (titleView) {
      segmentClassName += ' cs-title-cell';
    }

    let segmentHeight = 0;
    let minSegmentHeight = titleView
      ? DefaultCompactTitleRowHeight
      : DefaultCompactRowHeight;

    segmentHeight = this._getRowHeightWithErrorHandler(
      itemWidth,
      segmentState,
      styles,
      segmentClassName,
      () => (corruptedCell = true),
    );

    segmentHeight =
      segmentHeight > minSegmentHeight ? segmentHeight : minSegmentHeight;

    let fullHeight = segmentHeight + CellBorders.Compact;

    fullHeight = corruptedCell
      ? fullHeight + this._getCorruptedItemCellHeight(itemWidth)
      : fullHeight;

    return fullHeight;
  },

  /**
   * Get the column width for an item column
   */
  _getItemColumnWidth() {
    const settings = this._getCueStateField('settings');
    return CuesheetHelper.getItemColumnWidth(settings, true);
  },

  /**
   * Corrupted cells do not correctly generate a row height. We
   * have pre-defined values to correctly display the corrupted
   * cell content message.
   */
  _getCorruptedItemCellHeight(width) {
    let heightLookup = {
      [ItemColumnSegmentWidths.UltraNarrow]: 100,
      [ItemColumnSegmentWidths.Narrow]: 175,
      [ItemColumnSegmentWidths.Normal]: 250,
      [ItemColumnSegmentWidths.Wide]: 400,
      [ItemColumnSegmentWidths.ScriptWide]: 600,
    };

    return heightLookup[width];
  },

  _getRowHeightWithErrorHandler(
    width,
    rteState,
    styles,
    className,
    errorHandler,
  ) {
    let height = 0;

    /**
     * Prevent show from breaking when cell is corrupted.
     * Check renderable content of cell to retrieve cell height.
     */
    try {
      height = RowHeightHelper.getHeight(width, rteState, styles, className);
    } catch (e) {
      if (errorHandler) errorHandler();
    }

    return height;
  },
});

/**
 * Get the height for the grid
 *
 * @returns {number}
 * @private
 */
function _getGridHeight() {
  const innerHeight = window.innerHeight,
    showHeader = document.getElementById('cs-header'),
    showFooter = document.getElementById('cs-footer'),
    showHeaderHeight = showHeader ? showHeader.offsetHeight : 69,
    showFooterHeight = showFooter ? showFooter.offsetHeight : 68,
    buffer = 2;

  const newHeight = innerHeight + buffer - showHeaderHeight - showFooterHeight;

  return newHeight;
}
